module.exports = __webpack_public_path__ + "media/audios/kid/lesson_5/audio_AnaAdivinhadora-c65940730ff03571797309039eea0ffa.m4a";